import $ from "jquery";
import HtmlElement from './HtmlElement';

/**
 * Form
 *
 * @return Array
 */
const Form = (() => {
  /**
   *  Fields
   *
   *  @var { Array }
   */
  const Fields = [
    'input:not([type="checkbox"]:not([type="radio"]))',
    'select',
    'textarea'
  ];

  /**
   * Selector
   *
   * @var { Object }
   */
  const Selector = {
    FORM: 'form',
    INPUT_WRAP: '.input-wrap',
    STREET_INPUT: '[id$="-street"]',
    STREETNR_INPUT: '[id$="-streetNumber"]',
    ZIP_INPUT: '[id$="-postcode"]',
    TOWN_INPUT: '[id$="-town"]',
    COUNTRY_INPUT: '[id$="-country"]'
  };

  /**
   * ClassName
   *
   * @var { Object }
   */
  const ClassName = {
    FORM_CUSTOM: 'form-custom',
    FIELD_FOCUSED: 'field-focused',
    FIELD_HAS_VALUE: 'field-has-value'
  };

  /**
   * Form
   *
   * @class
   * @augments HtmlElement
   */
  class Form extends HtmlElement {
    // Public

    /**
     * Handles ready event
     *
     * @return void
     */
    onReady() {
      this._$fields = this.$element.find(Fields.join());

      this.streetInput = this.$element.find(Selector.STREET_INPUT);
      this.streetnumberInput = this.$element.find(Selector.STREETNR_INPUT);
      this.zipInput = this.$element.find(Selector.ZIP_INPUT);
      this.townInput = this.$element.find(Selector.TOWN_INPUT);
      this.countryInput = this.$element.find(Selector.COUNTRY_INPUT);

      // Add places suggest for street
      // if (this.streetInput.length) {
      //     this.initStreetAutocomplete();
      // }
      // // Add places suggest for zip
      // if (this.zipInput.length) {
      //     this.initZipAutocomplete();
      // }

      this._bindHandlers();
      this._initializeDatepicker();
      this._initializeSubjectOptions();
      this._initializeFileUploads();

      // Fill hidden "source" field with spam protection value
      this.$element.find('input.formSource').val('?8K{WL)R5q!Jf,{9');

      // Validatde Form
      $(".form-custom").validate({
        errorElement: "span",
        errorPlacement: function (error, element) {
          // Add the `invalid-feedback` class to the error element
          error.addClass("form-error");

          if (element.prop("type") === "checkbox") {
            error.insertAfter(element.parent("label"));
          } else if (element.prop("type") === "radio") {
            error.insertAfter(element.closest("fieldset"));
          } else {
            error.insertAfter(element);
          }
        },
        highlight: function (element) {
          $(element).addClass("is-invalid-input").removeClass("is-valid");
        },
        unhighlight: function (element) {
          $(element).addClass("is-valid").removeClass("is-invalid-input");
        }
      });

      // the following method must come AFTER .validate()
      $("input[name*='dataProtection']").each(function () {
        $(this).rules('add', {
          required: true
        });
      });
      $("input[name*='mail']").each(function () {
        $(this).rules('add', {
          required: true,
          email: true
        });
      });
    }

    async initZipAutocomplete() {
        let countriesRestriction = [];
        if (document.documentElement.lang === 'de') {
            countriesRestriction = ['DE', 'AT', 'CH'];
        }
      const {Autocomplete} = await google.maps.importLibrary("places")
      /* eslint-disable no-undef */
      this.zipAutocomplete = new Autocomplete(this.zipInput[0], {
        types: ['(regions)'],
        componentRestrictions: {country: countriesRestriction}
      });
      /* eslint-enable no-undef */
      this.zipAutocomplete.setFields(['address_component']);
      this.zipAutocomplete.addListener('place_changed', () => this.fillInAddressFromZip());
      this.zipInput.attr('placeholder', '');
      this.zipInput.attr('autocomplete', 'no');
    }

    async initStreetAutocomplete() {
        let countriesRestriction = [];
        if (document.documentElement.lang === 'de') {
            countriesRestriction = ['DE', 'AT', 'CH'];
        }
      const {Autocomplete} = await google.maps.importLibrary("places")
      /* eslint-disable no-undef */
      this.streetAutocomplete = new Autocomplete(this.streetInput[0], {
        /* eslint-enable no-undef */
        types: ['geocode'],
        componentRestrictions: {country: countriesRestriction}
      });
      this.streetAutocomplete.setFields(['address_component']);
      this.streetAutocomplete.addListener('place_changed', () => this.fillInAddressFromStreet());
      this.streetInput.attr('placeholder', '');
      this.streetInput.attr('autocomplete', 'no');
    }

    /**
     * Initiate fill-in of address fields from zip input
     */
    fillInAddressFromZip() {
      this.fillInAddress(this.zipAutocomplete.getPlace());
    }

    /**
     * Initiate fill-in of address fields from street input
     */
    fillInAddressFromStreet() {
      this.fillInAddress(this.streetAutocomplete.getPlace());
    }

    /**
     * Fill address fields with google places result
     * @see https://developers.google.com/maps/documentation/javascript/examples/places-autocomplete-addressform
     */
    fillInAddress(place) {
      const componentForm = {
        street_number: ['short_name', 'streetnumberInput'],
        route: ['long_name', 'streetInput'],
        postal_code: ['short_name', 'zipInput'],
        locality: ['long_name', 'townInput'],
        country: ['long_name', 'countryInput']
      };
      for (let i = 0; i < place.address_components.length; i++) {
        const addressType = place.address_components[i].types[0];
        if (componentForm[addressType]) {
          const val = place.address_components[i][componentForm[addressType][0]];
          this[componentForm[addressType][1]].val(val);
          this[componentForm[addressType][1]].parent('div').addClass('field-has-value');
        }
      }
    }

    // Private

    /**
     * Binds event handlers to the elements
     *
     * @return void
     */
    _bindHandlers() {
      if (this.$element.hasClass(ClassName.FORM_CUSTOM)) {
        this._$fields.each((i, field) => {
          let $field = $(field);

          this._fieldHandleInput($field);

          $field.on('focus', () => {
            this._fieldFocus($field);
          });

          $field.on('blur', () => {
            this._fieldBlur($field);
          });

          $field.on('input change', () => {
            this._fieldHandleInput($field);
          });
        });
      }

    }

    /**
     * Initializes the datepicker
     *
     * @return void
     */
    _initializeDatepicker() {
      this.$element.find('input[type="text"]').each((i, field) => {
        let $field = $(field),
          $inputWrap = $field.parent(Selector.INPUT_WRAP);

        if ($inputWrap.hasClass('datepicker')) {
          $field.datepicker({
            dateFormat: 'dd.mm.yy',
            showAnim: 'fadeIn',
            showOtherMonths: true,
            selectOtherMonths: true
          });

          $field.datepicker('option', $.datepicker.regional['de']);
          $field.datepicker('option', {
            prevText: '<i class="fal fa-angle-left"></i>',
            nextText: '<i class="fal fa-angle-right"></i>'
          });
        }
      });
    }

    /**
     * Initializes the subject options
     * NOTE: The "phone" option must be the first one. Otherwise the "required" toggling function won't work anymore.
     *
     * @return void
     */
    _initializeSubjectOptions() {
      let $subjectOptions = this.$element.find('[id*="-subject"]'),
        $phone = this.$element.find('[id*="-phone"]'),
        $town = this.$element.find('[id*="-town"]'),
        $street = this.$element.find('[id*="-street"]').not('[id*="-streetNumber"]'),
        $streetNumber = this.$element.find('[id*="-streetNumber"]');

      const isSparePartForm = this.$element.is('[id^="sparepart-"]');

      if ($subjectOptions.length > 0 && $phone.length > 0) {
        let $phoneLabel = $phone.prev('label'),
          phoneLabelText = $phoneLabel.html(),
          phoneLabelRequiredText = $phone.attr('requiredLabel');

        const $townLabel = $town.prev('label'),
          townLabelText = $townLabel.html(),
          townLabelRequiredText = $town.attr('requiredLabel'),
          $streetLabel = $street.prev('label'),
          streetLabelText = $streetLabel.html(),
          streetLabelRequiredText = $street.attr('requiredLabel'),
          $streetNumberLabel = $streetNumber.prev('label'),
          streetNumberLabelText = $streetNumberLabel.html(),
          streetNumberLabelRequiredText = $streetNumber.attr('requiredLabel');

        $subjectOptions.on('change', (e) => {
          if ($(e.target).val() == 3) {
            $phone.attr('required', 'required');
            $phoneLabel.html(phoneLabelRequiredText);
          } else if (isSparePartForm && $(e.target).val() == 2) {
            $town.attr('required', 'required');
            $townLabel.html(townLabelRequiredText);
            $street.attr('required', 'required');
            $streetLabel.html(streetLabelRequiredText);
            $streetNumber.attr('required', 'required');
            $streetNumberLabel.html(streetNumberLabelRequiredText);
          } else {
            $phone.removeAttr('required');
            $phoneLabel.html(phoneLabelText);

            if (isSparePartForm) {
              $town.removeAttr('required');
              $townLabel.html(townLabelText);
              $street.removeAttr('required');
              $streetLabel.html(streetLabelText);
              $streetNumber.removeAttr('required');
              $streetNumber.html(streetNumberLabelText);
            }
          }
        });
      }
    }

    _initializeFileUploads() {
      const $fileUploads = this.$element.find('.file-upload');
      const $submitButton = this.$element.find('button[type="submit"]');

      if ($fileUploads.length) {
        const preventDefaults = (e) => {
          e.preventDefault();
          e.stopPropagation();
        }

        $fileUploads.each((i, el) => {
          const input = el.querySelector('input[type="file"]');
          const dropArea = el.querySelector('.file-upload-drop-area');
          const filesList = el.querySelector('.file-upload-files');
          const $formError = $(el).next('.form-error');
          const $clientFormError = $(el).find('.form-error');
          const $size = $(el).find('.file-upload-size');
          const $meta = $(el).find('.file-upload-meta');
          const $clear = $(el).find('.file-upload-clear');
          const errorMimeType = $clientFormError.data('error-mime-type');

          const onHighlight = () => {
            $(el).addClass('file-upload-highlight');
          };

          const onUnhighlight = () => {
            $(el).removeClass('file-upload-highlight');
          };

          const getTotalFileSize = () => {
            const files = [...input.files];

            if (files.length < 1) {
              return 0;
            }

            return files.map(file => file.size).reduce((acc, curr) => acc + curr);
          };

          const checkFileSizes = () => {
            const maxFileSize = 5000000; // 5 MB
            const totalFileSize = getTotalFileSize();

            $formError.remove();

            if (totalFileSize > maxFileSize) {
              $submitButton.prop('disabled', true);
              $size.addClass('exceeded');
            } else {
              $submitButton.prop('disabled', false);
              $size.removeClass('exceeded');
            }
          };

          const updateSize = () => {
            $size.html(`${(getTotalFileSize() * 0.000001).toFixed(2)} MB / 5 MB`);
          };

          const updateMeta = () => {
            if ([...input.files].length > 0) {
              $meta.css('display', 'flex');
            } else {
              $meta.css('display', 'none');
            }
          };

          const handleFiles = () => {
            hideError();
            checkFileSizes();
            updateSize();
            updateFilesList();
            updateMeta();
          };

					const getFileIcon = (type) => {
						switch (type) {
							case 'image/jpeg':
							case 'image/png':
								return 'file-image';
							case 'application/pdf':
								return 'file-pdf';
							default:
								return 'file';
						}
					};

					const showError = (msg) => {
						$clientFormError.html(msg);
						$clientFormError.css('display', 'inline');
					};

          const hideError = () => {
            $clientFormError.empty();
            $clientFormError.css('display', 'none');
          };

          const checkFileTypes = (files) => {
            const allowedExtensions = ['jpg', 'jpeg', 'png', 'pdf'];
            return [...files].every(file => allowedExtensions.includes(file.name.split('.').pop()));
          };

          const updateFilesList = () => {
            $(filesList).empty();

            [...input.files].forEach((file, index) => {
              const fileReader = new FileReader();
              fileReader.readAsDataURL(file);
              fileReader.onloadend = () => {
                let imgHtml = '';

                if (/\.(jpe?g|png)$/i.test(file.name)) {
                  imgHtml = `<img src="${fileReader.result}" width="100" />`;
                } else if (/\.(pdf)$/i.test(file.name)) {
                  const pdfSrc = URL.createObjectURL(file);
                  imgHtml = `<embed src="${pdfSrc}#toolbar=0&scrollbar=0" width="100" height="100" />`;
                }

                const itemHtml = `
									<li data-item="${index}">
										<div>
											${imgHtml}
											<span>${file.name}</span>
										</div>
									</li>
								`;

                $(filesList).prepend(itemHtml);
              };
            });
          };

          /* const removeFile = (fileIndex) => {
            const files = [...input.files];
            files.splice(fileIndex, 1);
            console.log(files);
            console.log('remove file with index ' + fileIndex);
          };

          filesList.addEventListener('click', (e) => {
            e.preventDefault();

            if (e.target) {
              const buttonClassName = 'file-upload-file-remove';
              const button = e.target.parentNode.className === buttonClassName ? e.target.parentNode : e.target.className === buttonClassName ? e.target : null;

              if (button) {
                removeFile(button.dataset.index);
              }
            }
          }); */

          // Handle input changes
          input.addEventListener('change', handleFiles, false);

          // Stop event default & propagation
          ['dragenter', 'dragover', 'dragleave', 'drop'].forEach((event) => {
            dropArea.addEventListener(event, preventDefaults, false);
          });

          ['dragenter', 'dragover'].forEach((event) => {
            dropArea.addEventListener(event, onHighlight, false);
          });

          ['dragleave', 'drop'].forEach((event) => {
            dropArea.addEventListener(event, onUnhighlight, false);
          });

          dropArea.addEventListener('drop', (e) => {
            if (!checkFileTypes(e.dataTransfer.files)) {
              showError(errorMimeType);
              return false;
            }

            input.files = e.dataTransfer.files;
            handleFiles();
          });

          $clear.on('click', (e) => {
            e.preventDefault();
            input.value = null;
            handleFiles();
          });
        });
      }
    }

    /**
     * Handles focus of the given field
     *
     * @param { jQuery } $field
     * @return void
     */
    _fieldFocus($field) {
      $field.parent(Selector.INPUT_WRAP).addClass(ClassName.FIELD_FOCUSED);
    }

    /**
     * Handles blur of the given field
     *
     * @param { jQuery } $field
     * @return void
     */
    _fieldBlur($field) {
      $field.parent(Selector.INPUT_WRAP).removeClass(ClassName.FIELD_FOCUSED);
    }

    /**
     * Handles input of the given field
     *
     * @param { jQuery } $field
     * @return void
     */
    _fieldHandleInput($field) {
      if ($field.val() !== '') {
        $field.parent(Selector.INPUT_WRAP).addClass(ClassName.FIELD_HAS_VALUE);
      } else {
        $field.parent(Selector.INPUT_WRAP).removeClass(ClassName.FIELD_HAS_VALUE);
      }
    }
  }

  return Form._getElements(Selector.FORM, Form);
})();

export default Form;
